import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { InterceptorSkipHeader } from '@core/http/http-headers';

@Injectable({ providedIn: 'root' })
export class AuthGoogleService {
  private http = inject(HttpClient);

  storeToken(t: string) { localStorage.setItem('token', t); }
  storeUser(u: any) { localStorage.setItem('user', JSON.stringify(u)); }
  clear() { localStorage.removeItem('token'); localStorage.removeItem('user'); }

  // googleCallback(credential: string) {
  //   return this.http.post<any>(`${env.apiUrl}/sso/google/callback`, { credential });
  // }

loginWithGoogleCredential(credential: string) {
  const headers = new HttpHeaders().set(InterceptorSkipHeader, '1');
  return this.http.post<{ token: string; user: any }>(
    `${env.apiUrl}/sso/google/callback`,
    { credential },
    { headers }
  );
}


}
